<template>
    <v-container class="pa-0 ma-0" fluid>
			<v-row class="px-0 my-2">
        <v-col cols=12 md=6>
          <v-select 
            v-model="rubro"
            :items="rubros"
            label="Rubro CONEX" 
            placeholder="Seleccione un valor"  
            class="caption" 
            item-value="rubro"
            item-text="descripcion"
            return-object
            dense 
            hide-details 
            clearable
          >
              <template v-slot:item={item}>
                  <v-list-item-content>
                    <v-list-item-title>({{item.rubro}}) {{item.descripcion}}</v-list-item-title>
                    <!--<v-list-item-subtitle v-html="item.descripcion"></v-list-item-subtitle>-->
                  </v-list-item-content>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip small :key="index">
                  <span>({{item.rubro}}) {{ item.descripcion }}</span>
                </v-chip>
               </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row class="px-0 my-2">
        <v-col cols=12 md=6 class="pb-0">
          <v-file-input 
            dense
            :loading="uploading" 
            show-size 
            label="Archivo" 
            v-model="file"
            :rules="rulesFiles"
          >
          </v-file-input>
        </v-col>
        <v-col class="pb-0">
          <v-btn color="primary" dark class="mb-2" @click="uploadFile" :loading="uploading">Leer</v-btn>
        </v-col>
				<v-col cols=12 >
          <v-data-table
            dense
            :headers="headers"
            :items="itemsImport"
            class="elevation-2"
            hide-default-header
            hide-default-footer
            disable-pagination
            :mobile-breakpoint=100
          >
            <template v-slot:top>
              <v-toolbar flat dense color="white" class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn color="success lighten-1  " small class="primary--text" :disabled="flgProcesar" :loading="loadProcesar" @click="procesarLista()">PROCESAR LISTA</v-btn>
              </v-toolbar>
            </template>

            <template v-slot:header="{props}">
              <tr >
                  <td
                    v-for="header in props.headers"
                    :key="header.text"
                    class="text-truncate body-2 primary white--text "
                    :class="header.class "
                    :align="header.align"
                    :width="header.width"
                    v-text="header.text"
                  />
              </tr>
            </template>

            <template v-slot:item="{item,isSelected,select,headers} ">
              <tr class="body-2">
                <template v-for="(h, idx) in headers" >
                  <td :align="h.align" :class="['body-2', h.class]" v-text="item[h.value]" :key="idx" />
                </template> 

              </tr>
            </template>
          </v-data-table>
        </v-col>

      </v-row>
    </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ImportarPrecios',

    components: {
      
    },

    data: () => ({
      rubro:null,
      rubros:[],

      file:undefined,
      uploading:false,
      rulesFiles: [
        value => {
          if (!value) return 'Debe selecionar un archivo'
          else  if(value.size > 12000000) return 'El archivo debe ser más pequeño, máximo 12 MB!'
          return true
          },
      ],

      headers: [
        { text: 'Código' ,align: 'start',sortable: false, value: 'codigo' },
        { text: 'Descip' ,align: 'start',sortable: false, value: 'des'},
        { text: 'Precio' ,align: 'end',  sortable: false, value: 'precio'},
      ],
      items:[],

      loadProcesar:false
    }),
    created: async function () {
      console.log("Componente creado")
      let response
      let opt={
          method: 'GET', 
          mode: 'cors'
      }

      response = await fetch(`${this.ROOT_API}cms/lstprecios/rubros`, opt);
      if (response.ok){
        this.rubros=await response.json()
        console.log(this.rubros)
      }



      //this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
      //this.loadItems()
    },

    filters:{
    },
    watch: {
    },

    methods: {
      initialize () {

      },
        
      async uploadFile (){
        console.log("UPLOAD")
        this.uploading=true

        /* */
        let prod=[]
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}productos`, opt)
        if (response.ok){
          prod=await response.json()

        }
        /* */

        let formData = new FormData()
        formData.append('file',this.file)

        opt={
            method: 'POST', 
            mode: 'cors',
            body: formData,

        }
        
        response = await fetch(`${this.ROOT_API}cms/upload/read`, opt);
        if (response.ok) {
          let r=await response.json()

          console.log("Resultado archivo-->", r)

          console.log("Productos --> ", prod)

          this.items=r.rows.map(item => {
            let found = prod.find(el => el.codigo==item.codigo)

            console.log(found)
            if (!found) found={}
            console.log(found)

            return {
              codigo:item.codigo,
              des:item.des,
              precio:item.precio,
              id: found.id || 0,
              precioA: found.precio || 0,
              desA:found.des || 0
            }
            
          })
        }
        else {
          console.log("error")
          
        }
        this.uploading=false
      },

      async deleteFile(file){
        console.log("DELETE FILE")

        let opt={
          method: 'DELETE', 
          mode: 'cors',
        }
        let response = await fetch(`${this.ROOT_API}cms/upload/listas/${file.name}`, opt);
        if (response.ok){
          this.loadItems()
        }

      },

      async procesarLista() {
        this.loadProcesar=true
        for await (let item of this.itemsImport){


          let param
          let id = item.id || "" 
          let url=`${this.ROOT_API}cms/lstprecios/procesar/${id}`

          item.precio=="0.00" ? item.estado=0 : item.estado=1 

          if (this.rubro){
            let {rubro=0, marcaID=0} = this.rubro

            item.rubro = rubro
            item.marcaID = marcaID
          }
          
          if (item.precio!="" || (id!=0 && item.precio=="0.00")){
            let opt={
                method: item.id ? 'put':'post', 
                mode: 'cors',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },  
                body: JSON.stringify(item),
              }

              let response = await fetch(url, opt);

              console.log(opt)
            

          }



   

          //let response = await fetch(`${this.ROOT_API}cms/subcategorias/${this.editedItem.id}`, opt);



          
        }
        this.loadProcesar=false
        this.items=[]
        this.file=undefined

        
      },

    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      itemsImport  () {
        let r=this.items.filter( item => item.id==0 || (item.precio!=item.precioA) || item.des!=item.desA )
        return r
      },
      
      flgProcesar () {
        return !(this.itemsImport.length? true:false)
      },
    },
  }
</script>

<style scoped>

</style>
